import {getAxios} from '@deviceinsight/ng-ui-api-client';
import {KisApiUser} from '../modules/kisapi/types';

export const listKisApiUsers = (customerId: string): Promise<KisApiUser[]> =>
	getAxios()
		.get(`/rafi/v1/subtenants/${customerId}/kisApiUsers`, {params: {size: 10}})
		.then((response) => response.data);

export const createKisApiUserWithDescr = (customerId: string, descr: object): Promise<KisApiUser> =>
	getAxios()
		.post(`/rafi/v1/subtenants/${customerId}/kisApiUsers`, descr)
		.then((response) => response.data);

export const deleteKisApiUser = (customerId: string, clientId: string): Promise<KisApiUser> =>
	getAxios()
		.delete(`/rafi/v1/subtenants/${customerId}/kisApiUsers/${clientId}`)
		.then((response) => response.data);

export const regenerateApiKey = (customerId: string, clientId: string): Promise<KisApiUser> =>
	getAxios()
		.post(`/rafi/v1/subtenants/${customerId}/kisApiUsers/${clientId}/regenerateApiKey`)
		.then((response) => response.data);
